import React from "react";
import { useImage } from "../AsyncImage";

const HeaderImage = ({ src }) => {
  const { hasLoaded, hasError } = useImage(src);

  let imageClass = "";
  let style = {};

  if (hasError) {
    return null;
  }

  if (hasLoaded) {
    imageClass = "loaded";
    style = {
      backgroundImage: `url(${src})`,
    };
  }

  return <div className={"image-header " + imageClass} style={style} />;
};

export default HeaderImage;
